import React from 'react';
import { Target, Zap, BarChart, Settings } from 'lucide-react';
import Layout from './Layout';
import FadeIn from './FadeIn';

const AgencySection: React.FC = () => {
  const features = [
    {
      icon: <Target className="w-12 h-12" />,
      title: "Personnalisation Totale",
      description: [
        "Créez des offres d'emploi entièrement personnalisables, adaptées à chaque secteur et à chaque poste.",
        "Bénéficiez de modèles préconçus, modifiables en quelques clics pour répondre aux attentes spécifiques de chaque client."
      ]
    },
    {
      icon: <Zap className="w-12 h-12" />,
      title: "Attractivité et Engagement",
      description: [
        "Utilisez un contenu dynamique et des techniques de rédaction issues du marketing digital pour rendre vos annonces irrésistibles.",
        "Optimisez la visibilité de vos offres sur les plateformes clés grâce à des stratégies éprouvées."
      ]
    },
    {
      icon: <Settings className="w-12 h-12" />,
      title: "Gain de Temps et Simplicité",
      description: [
        "Simplifiez la gestion de vos offres avec une interface intuitive qui intègre les meilleures pratiques du secteur.",
        "Automatisez la diffusion de vos annonces sur plusieurs plateformes pour maximiser votre portée sans effort supplémentaire."
      ]
    },
    {
      icon: <BarChart className="w-12 h-12" />,
      title: "Analyse et Optimisation",
      description: [
        "Suivez en temps réel les performances de vos annonces pour ajuster et améliorer votre stratégie de recrutement.",
        "Exploitez des outils d'analyse pour mesurer l'impact et identifier rapidement les axes d'amélioration."
      ]
    }
  ];

  return (
    <section id="agency-section" className="py-20 bg-gradient-to-br from-purple-50 to-indigo-50 scroll-mt-20">
      <Layout>
        <FadeIn>
          <div className="text-center mb-16">
            <h2 className="text-h2-mobile md:text-h2 mb-4">
              PimpMyJob pour les <span className="gradient-text">cabinets de recrutement</span>
            </h2>
            <h2 className="text-h2-mobile md:text-h2 mb-6">
              Vos clients sont uniques ? Offrez-leur des offres d'emploi qui leur ressemblent
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Rédigez des Offres d'Emploi Sur-Mesure, Engageantes et Différenciantes
            </p>
            <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
              Dans un marché du recrutement de plus en plus tendu, il est crucial pour les cabinets de se démarquer 
              auprès de leurs clients et prospects. Notre solution vous permet de créer des annonces personnalisées 
              qui non seulement captent l'attention des talents, mais qui renforcent également votre position concurrentielle.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <FadeIn key={index} delay={index * 100}>
              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="text-indigo-600 mb-6">
                  {feature.icon}
                </div>
                <h3 className="text-h3-mobile md:text-h3 mb-4">{feature.title}</h3>
                <div className="space-y-4">
                  {feature.description.map((desc, i) => (
                    <p key={i} className="text-gray-600">{desc}</p>
                  ))}
                </div>
              </div>
            </FadeIn>
          ))}
        </div>

        <FadeIn delay={400}>
          <div className="mt-12 text-center">
            <button className="btn-primary">
              Découvrir notre offre cabinet
            </button>
          </div>
        </FadeIn>
      </Layout>
    </section>
  );
};

export default AgencySection;